import styled from 'styled-components';
import { media, EllipsisWithLineClamp } from '@simplywallst/ui-core';

export const LogoWrapper = styled('div')`
  margin-right: ${({ theme }) => theme.x3spacePx}px;
`;

export const Heading = styled('h1')`
  ${({ theme }) => theme.typography.massStrong};
  color: ${({ theme }) => theme.color.charcoal};
  margin: 0;
  ${media.mdDown`
    margin-top: 12px;
    margin-bottom: 12px;
  `}
`;

export const SubHeading = styled('p')`
  ${({ theme }) => theme.typography.xSmall};
  color: ${({ theme }) => theme.color.charcoal};
`;

export const CardTitle = styled('h2')`
  ${({ theme }) => theme.typography.baseStrong};
  color: ${({ theme }) => theme.color.charcoal};
  ${EllipsisWithLineClamp(2)}
  ${media.lgUp`
    max-width: 270px;
    min-height: 54px;
  `}
  margin: 0;
`;

export const CardWrapper = styled('div')`
  ${media.mdDown`
    padding: 0 ${({ theme }) => theme.x4spacePx}px;
  `}

  ${media.smDown`
    padding-bottom: ${({ theme }) => theme.x5spacePx}px;
  `}
`;

export const MobileWrapper = styled('div')`
  padding: ${({ theme }) => theme.x4spacePx}px;
`;

export const AuthorWrapper = styled('div')`
  margin: 5px 0px;
`;

export const ArticleTitleWrapper = styled('div')`
  margin-top: ${({ theme }) => theme.x2spacePx}px;
`;

export const InsightsLogoBanner = styled('div')`
  height: ${({ theme }) => theme.x5spacePx}px;
  background: ${({ theme }) => theme.color.chart02};

  svg {
    margin-left: ${({ theme }) => theme.x2spacePx}px;
    margin-top: ${({ theme }) => theme.x1spacePx}px;
  }
`;

export const ArticleHighlightWrapper = styled('div')`
  margin-top: ${({ theme }) => theme.x6spacePx}px;
  margin-bottom: ${({ theme }) => theme.x10spacePx}px;

  img {
    ${media.mdUp`
      max-width: 100%;
    `}
  }

  p {
    ${media.mdUp`
      max-width: 100%;
    `}
    ${EllipsisWithLineClamp(5)}
  }
`;

export const ArticleHighlightTitle = styled('h2')`
  ${({ theme }) => theme.typography.megaStrong};
  color: ${({ theme }) => theme.color.charcoal};
  margin: 0;
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
`;

export const ArticleHighlightContent = styled('div')`
  padding: ${({ theme }) => theme.x5spacePx}px;
  ${media.lgDown`
    padding-top: 0;
  `}
`;

export const Byline = styled('div')`
  ${(props) => props.theme.typography.xSmall};
  color: ${(props) => props.theme.color.spaceGrayRGBA(0.7)};

  a:not(:active) {
    text-decoration: none;
    color: ${(props) => props.theme.color.spaceGray};
  }

  span,
  time {
    vertical-align: middle;
    display: inline-block;
  }

  span:after {
    content: '|';
    padding: 0 ${(props) => props.theme.x1spacePx}px;
  }
`;

export const AuthorPhoto = styled('figure')`
  display: inline-block;
  vertical-align: middle;
  margin-right: ${(props) => props.theme.x1spacePx}px;
  width: ${({ theme }) => theme.x3spacePx}px;
  height: ${({ theme }) => theme.x3spacePx}px;
  border-radius: 100%;
  overflow: hidden;

  img {
    width: ${({ theme }) => theme.x3spacePx}px;
    height: ${({ theme }) => theme.x3spacePx}px;
    object-fit: cover;
  }
`;

export const ExcerptHighlightWrapper = styled('div')`
  margin-top: ${({ theme }) => theme.x3spacePx}px;
`;

export const ExcerptCardWrapper = styled('div')`
  margin-top: ${({ theme }) => theme.x2spacePx}px;
  ${media.mdUp`
    min-height: ${({ theme }) => theme.x14spacePx}px;
  `}
`;

export const ExcerptContent = styled('p')`
  ${(props) => props.theme.typography.small}
  color: ${(props) => props.theme.color.spaceGray};
  line-height: ${({ theme }) => theme.x3spacePx}px;
  ${EllipsisWithLineClamp(4)}
  ${media.lgUp`
    max-width: 270px;
  `}
`;

export const CoverImage = styled('img')`
  border-radius: 4px;
`;

export const Divider = styled('hr')`
  margin: ${({ theme }) => theme.x3spacePx}px;
  color: ${({ theme }) => theme.color.charcoalRGBA(0.1)};
  border-top: ${({ theme }) => `1px solid ${theme.color.charcoal}`};
  opacity: 0.1;
  margin-left: 0;
`;
